import { makeSx } from '../../../theme/_utils'

export default makeSx({
    container: {
        padding: '4rem 0',
    },
    title: {
        marginTop: '1rem',
        fontSize: '1rem',
    },
})
